import { IPOs } from '@benzinga/calendar-manager';
import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchIPO = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<IPOs[]> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();
  return Calendar.getIPOs(query).then(({ data }: { data: { ipos: IPOs[] } }) => {
    const items: IPOs[] = [];
    if (Array.isArray(data.ipos) && data.ipos.length) {
      return injectTickersLogos ? injectLogos(data.ipos) : data.ipos;
    }
    return items;
  });
};

export { fetchIPO };
